export default __webpack_public_path__ + "53fb94e9009cebdfccf5d5c8b34fa3bf.svg";